import { CustomerTransactions } from '@src/containers/Dealer/CustomerTransactions';
import type { CustomerTransfersBlotterPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CustomerTransfersPanel({ params, api }: LayoutPanelProps<CustomerTransfersBlotterPanelConfig>) {
  return (
    <BlotterPanel
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-transfers-blotter-panel"
    >
      <CustomerTransactions showHeader={false} />
    </BlotterPanel>
  );
}
